import Vue from "vue";
import Vuex from "vuex";
import { db } from "./db";
import firebase from "firebase";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null
    },
    currentUser: "",
    services: [],
    service: {},
    contacts: {
      email: "ola@exceptionjr.com.br",
      phone: "+55 (94) 99115-7251",
      socialMedias: [
        {
          name: "Instagram",
          perfilName: "@exception.jr",
          icon: ["fab", "instagram"],
          url: "https://www.instagram.com/exception.jr/"
        },
        {
          name: "Facebook",
          perfilName: "Exception jr",
          icon: ["fab", "facebook-square"],
          url: "https://www.facebook.com/exceptionjr"
        }
      ]
    },
    address:
      "Folha 17, Quadra 04, Lote Especial, s/n.º - Nova Marabá, Pará, Brasil, Terra, Sistema Solar, Via Lactea",
    menuLinks: [
      {
        title: "sobre",
        to: "/about"
      },
      {
        title: "serviços",
        to: "/services"
      },
      {
        title: "projetos",
        to: "/projects"
      },
      {
        title: "contato",
        to: "/contacts"
      },
      {
        title: "processo seletivo",
        to: "/processoseletivo"
      }
    ]
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, value) {
      state.user.data = value;
    },
    SET_SERVICE(state, value) {
      state.service = value;
    },
    setServices(state, payload) {
      state.services = payload;
    },
    setCurrentUser(state, payload) {
      state.currentUser = payload;
    }
  },
  actions: {
    fetchService({ commit }, slug) {
      let service = db
        .collection("services")
        .where("slug", "==", slug)
        .get()
        .then(querySnapshot => {
          // querySnapshot[0].data
          querySnapshot.forEach(doc => {
            commit("SET_SERVICE", doc.data());
            // console.log(doc.data());
          });
        });
      // console.log(service);
    },
    FETCH_SERVICES({ commit }) {
      db.collection("services")
        .get()
        .then(querySnapshot => {
          const services = querySnapshot.docs.map(doc => doc.data());
          commit("setServices", services);
        });
    },
    LOGIN({ commit }, payload) {
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(resp => {
          // console.log(resp.user.uid);
          commit("setCurrentUser", resp.user.uid);
        })
        .catch(error => {
          alert(error.message);
        });
    },
    fetchUser({ commit }) {
      let user = firebase.auth().currentUser;
      commit("SET_LOGGED_IN", user !== null);

      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email
        });
      } else {
        commit("SET_USER", null);
      }
    }
  }
});
